"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumSchLayerMap = exports.AltiumSpecificSchLayerTypes = exports.AltiumSchLayerSelector = exports.ALTIUM_SCH_LAYERSET = exports.ALTIUM_BRD_LAYERSET = void 0;
exports.getAltiumDefaultLayerSets = getAltiumDefaultLayerSets;
exports.getAltiumSchLayerByRecordType = getAltiumSchLayerByRecordType;
exports.getAltiumSchLayerByType = getAltiumSchLayerByType;
exports.getAltiumSchLayers = getAltiumSchLayers;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const SchDocTypes_1 = require("./parsers/schdoc/SchDocTypes");
const { toArray } = sigma_engine_shared_1.Utils;
const { PcbLayerType, SchLayerType } = sigma_engine_shared_1.DesignModels;
exports.ALTIUM_BRD_LAYERSET = 'altiumbrd';
exports.ALTIUM_SCH_LAYERSET = 'altiumsch';
class AltiumLayerSelector {
    filterLayers(name) {
        return this.getLayersByName(name);
    }
    getLayerByRecordType(recordType, defaultType) {
        return this.getLayerByType(defaultType);
    }
    getLayerByType(layer) {
        const layers = this.getLayersByType(layer);
        if (layers) {
            return layers[0];
        }
        return this.getLayerByType(sigma_engine_shared_1.DesignModels.UnknownLayerType.Other);
    }
    getLayers() {
        return Array.from(this.enumerateLayers());
    }
}
class AltiumSchLayerSelector extends AltiumLayerSelector {
    getLayersByName(name) {
        return toArray(Array.from(exports.AltiumSchLayerMap.values()).find((l) => l.name === name));
    }
    getLayersByType(type) {
        return toArray(exports.AltiumSchLayerMap.get(type));
    }
    enumerateLayers() {
        return exports.AltiumSchLayerMap.values();
    }
}
exports.AltiumSchLayerSelector = AltiumSchLayerSelector;
function getAltiumDefaultLayerSets() {
    return {
        [exports.ALTIUM_SCH_LAYERSET]: {
            type: 'layerSet',
            layerSetType: 'schematic',
            id: exports.ALTIUM_SCH_LAYERSET,
            layers: new AltiumSchLayerSelector().getLayers().map((l) => {
                l.defaultVisible = true;
                return l;
            }),
        },
    };
}
function getAltiumSchLayerByRecordType(recordType, defaultType = SchLayerType.Other) {
    switch (recordType) {
        case SchDocTypes_1.RecordType.WIRE:
            return getAltiumSchLayerByType(SchLayerType.Wire);
        case SchDocTypes_1.RecordType.BUS:
            return getAltiumSchLayerByType(SchLayerType.Bus);
        case SchDocTypes_1.RecordType.SIGNAL_HARNESS:
            return getAltiumSchLayerByType(SchLayerType.Bus);
        case SchDocTypes_1.RecordType.JUNCTION:
            return getAltiumSchLayerByType(SchLayerType.Junction);
        case SchDocTypes_1.RecordType.BUS_ENTRY:
            return getAltiumSchLayerByType(SchLayerType.BusJunction);
        case SchDocTypes_1.RecordType.LABEL:
            return getAltiumSchLayerByType(SchLayerType.Label);
        case SchDocTypes_1.RecordType.NET_LABEL:
            return getAltiumSchLayerByType(SchLayerType.Label);
        case SchDocTypes_1.RecordType.PIN:
            return getAltiumSchLayerByType(SchLayerType.Pin);
        case SchDocTypes_1.RecordType.SHEET_SYMBOL:
            return getAltiumSchLayerByType(SchLayerType.Symbol);
        case SchDocTypes_1.RecordType.HARNESS_CONNECTOR:
            return getAltiumSchLayerByType(SchLayerType.Symbol);
        case SchDocTypes_1.RecordType.HARNESS_ENTRY:
            return getAltiumSchLayerByType(SchLayerType.Symbol);
        case SchDocTypes_1.RecordType.HARNESS_TYPE:
            return getAltiumSchLayerByType(SchLayerType.Label);
        case SchDocTypes_1.RecordType.SHEET_ENTRY:
            return getAltiumSchLayerByType(SchLayerType.Pin);
        case SchDocTypes_1.RecordType.POWER_PORT:
            return getAltiumSchLayerByType(SchLayerType.Symbol);
        case SchDocTypes_1.RecordType.PORT:
            return getAltiumSchLayerByType(SchLayerType.Symbol);
        case SchDocTypes_1.RecordType.COMPONENT:
            return getAltiumSchLayerByType(SchLayerType.Symbol);
        case SchDocTypes_1.RecordType.TEXT_FRAME:
            return getAltiumSchLayerByType(SchLayerType.Label);
        case SchDocTypes_1.RecordType.NOTE:
            return getAltiumSchLayerByType(SchLayerType.Label);
        case SchDocTypes_1.RecordType.DESIGNATOR:
            return getAltiumSchLayerByType(SchLayerType.NameLabel);
        case SchDocTypes_1.RecordType.PARAMETER:
            return getAltiumSchLayerByType(SchLayerType.ValueLabel);
        case SchDocTypes_1.RecordType.IMPLEMENTATION_LIST:
            return getAltiumSchLayerByType(SchLayerType.Other);
    }
    return getAltiumSchLayerByType(defaultType);
}
function getAltiumSchLayerByType(layer) {
    return exports.AltiumSchLayerMap.get(layer);
}
function getAltiumSchLayers() {
    return Array.from(exports.AltiumSchLayerMap.values());
}
var AltiumSpecificSchLayerTypes;
(function (AltiumSpecificSchLayerTypes) {
    AltiumSpecificSchLayerTypes["Drawings"] = "Drawings";
    AltiumSpecificSchLayerTypes["TitleBlock"] = "TitleBlock";
})(AltiumSpecificSchLayerTypes || (exports.AltiumSpecificSchLayerTypes = AltiumSpecificSchLayerTypes = {}));
exports.AltiumSchLayerMap = new Map([
    [SchLayerType.Label, { id: 1, type: SchLayerType.Label, name: 'Label' }],
    [SchLayerType.NameLabel, { id: 2, type: SchLayerType.NameLabel, name: 'NameLabel' }],
    [SchLayerType.ValueLabel, { id: 3, type: SchLayerType.ValueLabel, name: 'ValueLabel' }],
    [SchLayerType.Pin, { id: 4, type: SchLayerType.Pin, name: 'Pin' }],
    [SchLayerType.PinName, { id: 5, type: SchLayerType.PinName, name: 'PinName' }],
    [SchLayerType.PinNumber, { id: 6, type: SchLayerType.PinNumber, name: 'PinNumber' }],
    [SchLayerType.Symbol, { id: 7, type: SchLayerType.Symbol, name: 'Symbol' }],
    [SchLayerType.Wire, { id: 8, type: SchLayerType.Wire, name: 'Wire' }],
    [SchLayerType.Bus, { id: 9, type: SchLayerType.Bus, name: 'Bus' }],
    [SchLayerType.Junction, { id: 10, type: SchLayerType.Junction, name: 'Junction' }],
    [SchLayerType.BusJunction, { id: 11, type: SchLayerType.BusJunction, name: 'BusJunction' }],
    [SchLayerType.Other, { id: 12, type: SchLayerType.Other, name: 'Other' }],
    [SchLayerType.Background, { id: 13, type: SchLayerType.Background, name: 'Background Contrast' }],
    [AltiumSpecificSchLayerTypes.Drawings, { id: 14, type: SchLayerType.Other, name: 'Drawings' }],
    [AltiumSpecificSchLayerTypes.TitleBlock, { id: 15, type: SchLayerType.Other, name: 'TitleBlock' }],
    [SchLayerType.Image, { id: 16, type: SchLayerType.Image, name: 'Image' }],
]);
//# sourceMappingURL=layers.js.map